import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Documentos Contabilizados — now unified into documentos-pendientes.
 * Redirects to the single unified documents page with "contabilizado" filter.
 */
export default function DocumentosContabilizados() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/asesor/documentos-pendientes?filter=contabilizado');
  }, [router]);

  return null;
}
